import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, CheckBox, FormField, Grid, Heading, Select, Text, TextArea, TextInput } from "grommet";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import Flag from "../components/Flag";
import NavigateToPath from "../components/NavigateToPath";
import ThemeBuilder from "../components/ThemeBuilder";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import TeamDetails from "./TeamDetails";
import TeamLogoPicker from "./TeamLogoPicker";
import { createTeam, CreateTeamRequest } from "./TeamsStore";

const BulkCreateTeams = () => {
    let [organization, setOrganization] = React.useState({} as Organization);

    const [teamNames, setTeamNames] = React.useState("");

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    let navigate = useNavigate();

    const [teams, setTeams] = React.useState([] as CreateTeamRequest[]);

    const [isPublic, setIsPublic] = React.useState(false);

    let create = async () => {
        setIsCreating(true);

        await Promise.all(teams.map((team) => createTeam(team)));

        navigate(`/teams/`);

        setIsCreating(false);
    };

    React.useEffect(() => {
        if (teamNames) {
            let teams = teamNames.split("\n").map((teamName) => {
                return {
                    name: teamName.trim(),
                    organizationID: organization.id,
                    countryCode: "ZA",
                } as CreateTeamRequest;
            });
            setTeams(teams);
        } else {
            setTeams([]);
        }
    }, [teamNames]);

    React.useEffect(() => {
        setTeams([...teams].map((team) => ({ ...team, isPublic: isPublic, organizationID: organization.id })));
    }, [isPublic, organization]);

    const handleLogoChange =
        (i) =>
        ({ uri, content }) => {
            let newTeams = [...teams];
            if (content) {
                newTeams[i].logoContent = content;
                newTeams[i].logoUri = "";
            } else if (uri) {
                newTeams[i].logoUri = uri;
                newTeams[i].logoContent = "";
            }
            setTeams(newTeams);
        };

    const handleColorChange = (i) => (color) => {
        let newTeams = [...teams];
        newTeams[i].color = color;
        setTeams(newTeams);
    };

    return (
        <div>
            <Box direction="row">
                <h1>Bulk Add Teams</h1>
                <NavigateToPath path="/teams/createBulk"></NavigateToPath>
            </Box>
            <Box width={{ max: "400px" }} pad="small" round="5px" background={"background"}>
                <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
                <FormField label="Team Names">
                    <TextArea value={teamNames} placeholder="One name per line" onChange={(e) => setTeamNames(e.target.value)}></TextArea>
                </FormField>

                <CheckBox label="Public" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} disabled={isCreating} />

                {teams.map((team, i) => (
                    <Box key={i}>
                        <Heading level={3}>{team.name}</Heading>
                        <Grid columns={{ count: 2, size: "auto" }}>
                            <TeamLogoPicker uri={team.logoUri} disabled={isCreating} onSelect={handleLogoChange(i)}></TeamLogoPicker>
                            <ThemeBuilder uri={team.logoUri || team.logoContent} color={team.color} onSelect={handleColorChange(i)} disabled={isCreating}></ThemeBuilder>
                        </Grid>
                    </Box>
                ))}
                <br />
                <Box direction="row">
                    {/* @ts-ignore */}
                    <CustomButton primary icon={<FontAwesomeIcon size="xl" icon={["fad", "layer-plus"]}></FontAwesomeIcon>} onClick={create} disabled={isCreating} label="Create"></CustomButton>
                </Box>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default BulkCreateTeams;
